import { render, staticRenderFns } from "./AdminPanelItem.vue?vue&type=template&id=677d364e"
import script from "./AdminPanelItem.vue?vue&type=script&lang=js"
export * from "./AdminPanelItem.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelItem.vue?vue&type=style&index=0&id=677d364e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports